import { http } from '@/lib/api-client'
import type {
  CreateTemplateInput,
  MessageChannel,
  MessageTemplate,
  UpdateTemplateInput,
} from './templates.types'

export const templateApi = {
  list: (channel: MessageChannel, activeOnly?: boolean): Promise<MessageTemplate[]> =>
    http
      .get<{ data: MessageTemplate[] }>('/message-templates', {
        params: { channel, ...(activeOnly ? { activeOnly: true } : {}) },
      })
      .then((r) => r.data),

  create: (data: CreateTemplateInput): Promise<MessageTemplate> =>
    http.post<{ data: MessageTemplate }>('/message-templates', data).then((r) => r.data),

  update: (id: string, data: UpdateTemplateInput): Promise<MessageTemplate> =>
    http
      .patch<{ data: MessageTemplate }>(`/message-templates/${id}`, data)
      .then((r) => r.data),

  delete: (id: string): Promise<void> => http.delete(`/message-templates/${id}`),
}
